import { all, put, takeEvery } from "@redux-saga/core/effects";
import {
  createProcedurePreset,
  editProcedurePreset
} from "../../Services/database";
import { setErrorStatus, setSuccessStatus } from "../status/action";

export const actionTypes = {
  CREATE_PROCEDURE_PRESET: "CREATE_PROCEDURE_PRESET",
  EDIT_PROCEDURE_PRESET: "EDIT_PROCEDURE_PRESET",
  ADD_PROCEDURES_DATA: "ADD_PROCEDURES_DATA",
  PUT_PROCEDURES_EXPORT_LOADING: "PUT_PROCEDURES_EXPORT_LOADING"
};

function* addProceduresDataWorker(action) {
  setProceduresLoading(true);
  yield put({
    type: "SET_PROCEDURES_DATA",
    payload: { data: action.payload.data }
  });
  yield setProceduresLoading(false);
}

function* createProcedurePresetWorker(action) {
  try {
    yield setProceduresLoading(true);
    yield createProcedurePreset({
      ...action.payload.data,
      createdAt: +new Date()
    });
    yield setSuccessStatus("Procedure preset created successfully");
    if (action.payload.navigate) {
      action.payload.navigate("/procedures");
    }
    yield setProceduresLoading(false);
  } catch (error) {
    yield setProceduresLoading(false);
    setErrorStatus(error, "from create Procedure");
  }
}

function* editProcedurePresetWorker(action) {
  try {
    yield setProceduresLoading(true);
    const data = action.payload.data;
    const documentId = data.documentId;
    delete data.documentId;
    yield editProcedurePreset(documentId, data);
    yield setSuccessStatus("Procedure preset edited successfully");
    if (action.payload.navigate) {
      action.payload.navigate(`/procedures/${documentId}`);
    }
    yield setProceduresLoading(false);
  } catch (error) {
    yield setProceduresLoading(false);
    setErrorStatus(error);
  }
}

function* setProcedureExportLoadingWorker(action) {
  yield put({
    type: "SET_PROCEDURES_EXPORT_LOADING",
    payload: {
      loading: action.payload.loading
    }
  });
}

export default function* proceduresWatcher() {
  yield all([
    takeEvery("ADD_PROCEDURES_DATA", addProceduresDataWorker),
    takeEvery("PUT_PROCEDURES_EXPORT_LOADING", setProcedureExportLoadingWorker),
    takeEvery("CREATE_PROCEDURE_PRESET", createProcedurePresetWorker),
    takeEvery("EDIT_PROCEDURE_PRESET", editProcedurePresetWorker)
  ]);
}

function* setProceduresLoading(bool) {
  yield put({
    type: "SET_PROCEDURES_LOADING",
    payload: {
      loading: bool
    }
  });
}
